<template>
  <div style="height:100%">
    <div class="d-flex flex-column" style="overflow-y: hidden; height: 100%">
    <v-form class="mt-2 flex-grow-0 flex-shrink-0">
      <v-row no-gutters align="center" >
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>预约单号：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-text-field
              dense
              outlined
              v-model="filter.code"
          ></v-text-field>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>订单号：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-text-field
              dense
              outlined
              v-model="filter.ordercode"
          ></v-text-field>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>供应商：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <vender-select v-model="filter.venderId"></vender-select>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>配送中心：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <park-select v-model="filter.parkId" :for-vender="false"></park-select>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>车牌：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-text-field
              dense
              outlined
              v-model="filter.carNumber"
          ></v-text-field>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>司机姓名：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-text-field
              dense
              outlined
              v-model="filter.driver"
          ></v-text-field>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>手机号：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-text-field
              dense
              outlined
              v-model="filter.driverMobile"
          ></v-text-field>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>预约方式：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-select dense outlined clearable :items="addTypeList" item-text="name" item-value="id" v-model="filter.addType"></v-select>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>卸货方式：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-select dense outlined clearable :items="dischargeTypeList" item-value="id" item-text="name" v-model="filter.dischargeType"></v-select>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>状态：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-select dense outlined clearable :items="statusList" item-text="name" item-value="id" v-model="filter.status"></v-select>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>预约日期：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <date-range label="" v-model="filter.dateRange"></date-range>
        </v-col>
        <v-col
            cols="2"
            offset="1"
        >
          <v-btn
              color="primary"
              depressed
              style="margin-right: 5px"
              @click="handleSearch"
              v-if="_hasButtonPermission('查询')"
          >查询</v-btn>
          <v-btn
              depressed
              @click="handleResetSearch"
              v-if="_hasButtonPermission('查询')"
          >重置</v-btn>

        </v-col>
      </v-row>
    </v-form>
    <v-row class="flex-grow-0 flex-shrink-0">
      <v-col>
      <v-menu offset-y v-if="_hasButtonPermission('发起预约')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              depressed
              v-bind="attrs"
              v-on="on"
          >
            发起预约
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group>
            <v-list-item
                v-for="(item, index) in items"
                :key="index"
                dense
                @click="handleAdd(item.id)"
            >
              <v-list-item-title >{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

        <v-btn depressed color="primary" class="ml-2" :disabled="select.length == 0" @click="batchAudit" v-if="_hasButtonPermission('批量审批')">审核</v-btn>
      </v-col>

      <v-col offset="2" cols="8" v-if="vender.hasRefund">
        <v-chip
            color="blue"
            label
            outlined
            large
            class="pa-2"
            style="width: 100%"
        >
          <v-icon
              icon="mdi-lock"
              color="blue"
              large
              class="ma-2"
          >
            mdi-information
          </v-icon>
          <div class="text-h6 ml-2">
            您有商品需要退货，请提前安排
          </div>

        </v-chip>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1 flex-shrink-1" style="position: relative">
      <v-col style="position: absolute; inset: 0px">
        <v-data-table
            :headers="headers"
            :items="desserts"
            class="elevation-1"
            :loading="loading"
            :server-items-length="totalDesserts"
            :page.sync="filter.pageNum"
            :items-per-page.sync="filter.pageSize"
            show-select
            v-model="select"
            item-key="id"
            fixed-header
            height="calc(100% - 59px)"
            style="height: 100%"
            @update:page="handlePageChanged"
            @update:items-per-page="handlePageSizeChanged"
        >
          <template v-slot:item.addType="{ item }">
            {{ addTypeList[item.addType - 1].name }}
          </template>
          <template v-slot:item.timeType="{ item }">
            {{ (item.timeType||item.timeType==0 )?item.timeType + '点-' + (item.timeType + 1) + '点' : '' }}
          </template>
          <template v-slot:item.status="{ item }">
            {{ statusList[item.status - 1].name }}
          </template>
          <template v-slot:item.actions="{ item,index }">
            <v-btn text color="primary" small @click="handleView(item)" v-if="_hasButtonPermission('查看')">查看</v-btn>
            <v-btn text color="primary" small v-if="session.userId == item.createId && item.status == 1 && _hasButtonPermission('撤销')" @click="handleWithdraw(item)">撤销</v-btn>
            <v-btn text color="primary" small v-if="session.userId == item.createId && item.status == 3 && _hasButtonPermission('取消')" @click="handleCancel(item)">取消</v-btn>
            <v-btn text color="primary" small v-if="(item.status == 3 || item.status == 1 || item.status == 8) && _hasButtonPermission('装车信息')" @click="handleCar(item)">装车信息</v-btn>
            <v-btn text color="primary" small v-if="session.userId == item.createId && item.status == 3 && _hasButtonPermission('预约调整')" @click="handleEdit(item)">预约调整</v-btn>
            <v-btn text color="primary" small v-if="session.userId == item.createId && (item.status == 6 || item.status ==7) && _hasButtonPermission('修改')" @click="handleEdit(item)">修改</v-btn>
            <v-btn text color="primary" small v-if="session.userId == item.auditId && item.status == 3 && _hasButtonPermission('取消审核')" @click="handleCancelAudit(item)">取消审核</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    </div>
    <v-dialog v-model="car.dialog" width="600">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"
        >装车信息
        </v-card-title
        >
        <v-card-text>
          <v-form ref="carForm">
          <v-container>
            <v-row align="center" >
              <v-col cols="3" style="text-align: right"><span class="red--text">*</span> 车牌号码：</v-col>
              <v-col cols="8" class="d-flex">
                <v-text-field outlined dense class="flex-shrink-1 flex-grow-1" :rules="[rules.required]" v-model="car.item.carNumber"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" style="text-align: right"><span class="red--text">*</span> 司机姓名：</v-col>
              <v-col cols="8" >
                <v-text-field outlined dense :rules="[rules.required]" v-model="car.item.driver"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" style="text-align: right"><span class="red--text">*</span> 手机号：</v-col>
              <v-col cols="8" >
                <v-text-field outlined dense :rules="[rules.required,rules.mobile]" v-model="car.item.driverMobile"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="car.dialog = false"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="saveCar"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VenderSelect from "@/components/appointment/VenderSelect";
import {default as ConfigApi} from "@/api/appointment/config/ConfigApi";
import ParkSelect from "@/components/appointment/ParkSelect";
import CsApi from "@/api/appointment/orders/CsApi";
import license from "../../../data/license.json";
import AppointmentApi from "@/api/appointment/orders/AppointmentApi";
export default {
  name: "AppointmentList",
  components: {ParkSelect, VenderSelect},
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data(){
    return {
      warning:'',
      items:[],
      filter:{
        pageNum: 1,
        pageSize:15,
        venderId:undefined,
        parkId:undefined,
        dateRange:[],
      },
      addTypeList:[{id:1,name:'按订单'},{id:2,name:'按商品'},{id:3,name:'紧急团购'}],
      statusList:[{id:1,name:'待审核'},{id:2,name:'审核未通过'},{id:3,name:'待履约'},{id:4,name:'已完成'},{id:5,name:'未履约'},
        {id:6,name:'已撤回'},{id:7,name:'已取消'},{id:8,name:'待OA审批'},{id:9,name:'OA审批未通过'},{id:10,name:'未生效'},],
      dischargeTypeList:[],
      vender:{
        hasRefund:false
      },
      //table
      headers: [
        {text: '预约单号', align: 'start', width:100,sortable: false, value: 'code',},
        { text: '订单号', value: 'ordercode',width: 120, sortable: false,},
        { text: '供应商', value: 'venderName' ,width: 200, sortable: false,},
        { text: '所属配送中心', value: 'parkName' ,width: 120, sortable: false,},
        { text: '月台范围', value: 'dockName' ,width: 120, sortable: false,},
        { text: '预约日期', value: 'scheduledDate' ,width: 120, sortable: false,},
        { text: '预约时段', value: 'timeType' ,width: 120, sortable: false,},
        { text: '车牌', value: 'carNumber' ,width: 120, sortable: false,},
        { text: '司机姓名', value: 'driver' ,width: 120, sortable: false,},
        { text: '手机号', value: 'driverMobile' ,width: 120, sortable: false,},
        { text: '预约方式', value: 'addType' ,width: 100, sortable: false,},
        { text: '卸货方式', value: 'dischargeName' ,width: 100, sortable: false,},
        { text: '状态', value: 'status' ,width: 100, sortable: false,},
        { text: '最后修改人', value: 'createBy' ,width: 120, sortable: false,},
        { text: '最后修改时间', value: 'createTime' ,width: 120, sortable: false,},
        { text: '操作', value: 'actions', sortable: false, width:300 },
      ],
      loading: true,
      desserts: [],
      totalDesserts:0,
      select:[],
      rules:{
        required: value => (!!value || value === 0) || '必填.',
        mobile: value=> ((!value && value !== 0)||(/^1[0-9]{10}$/.test(value))) || '请输入正确的手机号',
      },
      car:{
        dialog:false,
        licenseList:[],
        item:{},
      }
    }
  },
  computed: {
    session() {
      let session = this.$store.getters['app/getSession'];
      if (!session)
        session = {userId: ''};
      return session;
    }
  },
  created() {
    this.getHasRefund();
    this.getDischargeTypeList();
    this.getDataFromApi();
    this.car.licenseList = license;
    console.log(this.car.licenseList);
  },
  methods: {
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    async getWarning() {
      let resp = await ConfigApi.getConfig({name: 'appointment.alert'});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取配置失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      let warning = data.data;
      warning = warning.replaceAll('\n', '<br/>');
      this.warning = warning;
    },
    async getHasRefund() {
      let resp = await CsApi.hasRefund();
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取供应商退货信息失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      this.vender = data.data;

      let items = [{title: '紧急团购预约', id: 3},]
      if (this.vender.appointmentType && this.vender.appointmentType.indexOf("2") > -1) {  //低温
        items = [{title: '按订单预约', id: 1},
          {title: '按商品预约', id: 2},
          {title: '紧急团购预约', id: 3},];
      } else if (this.vender.appointmentType && this.vender.appointmentType.indexOf("1") > -1) { //高温
        items = [
          {title: '按订单预约', id: 1},
          {title: '紧急团购预约', id: 3},
        ]
      } else if (this.vender.appointmentType && this.vender.appointmentType.indexOf("3") > -1) { //果蔬
        items = [
          {title: '按商品预约', id: 2},
          {title: '紧急团购预约', id: 3},
        ]
      }
      this.items = items;
    },
    async getDischargeTypeList() {
      let resp = await AppointmentApi.dischargeType();
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取卸货方式列表失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      this.dischargeTypeList = data.data;
    },
    handleAdd(addType) {
      this.$emit("formCallback", {formStatus: 'add', addType: addType})
    },
    getQueryParams(param) {
      let query = Object.assign({}, param);
      let rangeDate = query.dateRange
      if (rangeDate && rangeDate.length) {
        query.startDate = rangeDate[0]
        query.endDate = rangeDate[1]
        delete query.dateRange;
      }
      return query
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      let queryUserResp = await AppointmentApi.list(this.getQueryParams(me.filter));
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取预约单失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },

    async batchAudit() {
      const res = await this.$dialog.confirm({
        title: '确认',
        text: '确定要审核通过这些选中的预约单吗？',
      });
      if (res == true) {
        let statusError = false;
        this.select.forEach(item=>{
          if(item.status != 1){
            statusError = true;
          }
        });
        if(statusError){
          this.$dialog.error({
            title:'错误',
            text:'只可审核 待审核 状态的预约单'
          })
          return;
        }
        let idList = this.select.map(item=> item.id);
        let resp = await AppointmentApi.batchAudit(idList);
        let data = resp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "批量审核失败" : msg;
          me.loading = false;
          throw new Error(msg);
        }
        this.select = [];
        this.getDataFromApi();
      }
    },
    handleSearch(){
      this.filter.pageNum = 1;
      this.getDataFromApi();
    },
    handleResetSearch(){
      this.filter = {
        pageNum: 1,
        pageSize:15,
        venderId:undefined,
        parkId:undefined,
        dateRange:[],
      }
      this.getDataFromApi();
    },
    handlePageChanged(page) {
      this.filter.pageNum = page
      this.getDataFromApi()
    },

    handlePageSizeChanged(pageSize) {
      this.filter.pageNum = 1
      this.filter.pageSize = pageSize
      this.getDataFromApi()
    },
    handleCar(item){
      this.car.dialog=true;
      this.car.item = {
        id:item.id,
        carNumber:item.carNumber,
        driver:item.driver,
        driverMobile:item.driverMobile,
        dischargeType:item.dischargeType
      };
      console.log(this.car.item);
    },
    async saveCar() {
      let valid = this.$refs.carForm.validate();
      if (valid) {
        let resp = await AppointmentApi.updateCar(this.car.item);
        let data = resp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "保存装车信息失败" : msg;
          throw new Error(msg);
        }
        this.car.dialog = false;
        this.getDataFromApi();
      }
    },
    handleView(item){
      this.$emit("formCallback", {formStatus: 'view', id: item.id})
    },
    async handleWithdraw(item) {
      let res = await this.$dialog.confirm({
        text: '确定撤回此预约单?',
        title: '确认'
      });
      if (res == true) {
        let resp = await AppointmentApi.withdraw(item.id);
        let data = resp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "撤回预约单失败" : msg;
          throw new Error(msg);
        }
        this.getDataFromApi();
        this.getHasRefund();
      }
    },
    async handleCancel(item) {
      let res = await this.$dialog.confirm({
        text: '确定取消此预约单?',
        title: '确认'
      });
      if (res == true) {
        let resp = await AppointmentApi.cancel(item.id);
        let data = resp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "取消预约单失败" : msg;
          this.$dialog.error({
            title:'错误',
            text:msg
          });
        }
        this.getDataFromApi();
        this.getHasRefund();
      }
    },
    handleEdit(item){
      this.$emit("formCallback", {formStatus: 'add', addType: item.addType, id:item.id})
    },
    async handleCancelAudit(item) {
      let res = await this.$dialog.confirm({
        text: '确定取消审核此预约单?',
        title: '确认'
      });
      if (res == true) {
        let resp = await AppointmentApi.cancelAudit(item.id);
        let data = resp.data;
        if (!data || !data.code || data.code != 200) {
          let msg = data.msg;
          msg = !msg || msg == "" ? "取消审核预约单失败" : msg;
          throw new Error(msg);
        }
        this.getDataFromApi();
        this.getHasRefund();
      }
    },
  }
}
</script>

<style scoped>

</style>